module.exports = __webpack_public_path__ + "media/images/ico-share-no-5fe43493.svg";